import React, { useState, useEffect } from "react";
import api from "../services/api";

export default function DashboardPage() {
  const [stats, setStats] = useState({ posts: 0, reports: 0, civil: 0, pending: 0 });
  const [recentPosts, setRecentPosts] = useState([]);
  const [recentReports, setRecentReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const postsRes = await api.get("/news/posts/?per_page=5");
        const posts = postsRes.data;
        setRecentPosts(posts.results || []);
        
        let reports = [];
        let civil = [];
        
        try {
          const reportsRes = await api.get("/news/reports/");
          reports = Array.isArray(reportsRes.data) ? reportsRes.data : [];
          setRecentReports(reports.slice(0, 3));
        } catch(e) { console.log('Reports error:', e.message); }
        
        try {
          const civilRes = await api.get("/civil-status/requests/");
          civil = Array.isArray(civilRes.data) ? civilRes.data : [];
        } catch(e) { console.log('Civil error:', e.message); }

        setStats({
          posts: posts.count || posts.results?.length || 0,
          reports: reports.length,
          civil: civil.length,
          pending: reports.filter(r => r.status === 'submitted').length,
        });
        setLoading(false);
      } catch(e) {
        console.error('Dashboard error:', e);
        setError(e.message);
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const StatCard = ({ icon, title, value, color, sub }) => (
    <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.06)", borderLeft: `4px solid ${color}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <p style={{ color: "#8A8A9A", fontSize: 13, margin: "0 0 8px" }}>{title}</p>
          <h2 style={{ color: "#1A1A2E", fontSize: 32, fontWeight: 800, margin: 0 }}>{value}</h2>
          {sub && <p style={{ color: color, fontSize: 12, margin: "4px 0 0" }}>{sub}</p>}
        </div>
        <span style={{ fontSize: 28 }}>{icon}</span>
      </div>
    </div>
  );

  if (loading) return <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Chargement...</div>;
  if (error) return <div style={{ textAlign: "center", padding: 60, color: "red" }}>Erreur: {error}</div>;

  return (
    <div>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 26, fontWeight: 800, margin: 0 }}>Tableau de bord</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>Bienvenue sur le panneau d'administration Bot-Makak</p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 20, marginBottom: 28 }}>
        <StatCard icon="📰" title="Total Actualites" value={stats.posts} color="#1A5C2A" sub="Publications actives" />
        <StatCard icon="📋" title="Signalements" value={stats.reports} color="#6A1B9A" sub={`${stats.pending} en attente`} />
        <StatCard icon="📁" title="Demandes Etat Civil" value={stats.civil} color="#1565C0" sub="Toutes demandes" />
        <StatCard icon="👥" title="Citoyens actifs" value="—" color="#E65100" sub="Bientot disponible" />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
          <h3 style={{ margin: "0 0 16px", color: "#1A1A2E", fontSize: 16, fontWeight: 700 }}>Dernieres actualites</h3>
          {recentPosts.length === 0 
            ? <p style={{ color: "#8A8A9A", fontSize: 13 }}>Aucune actualite publiee</p> 
            : recentPosts.map(p => (
              <div key={p.id} style={{ padding: "10px 0", borderBottom: "1px solid #F5F6FA", display: "flex", justifyContent: "space-between" }}>
                <div>
                  <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#1A1A2E" }}>{p.title?.substring(0, 35)}...</p>
                  <p style={{ margin: 0, fontSize: 12, color: "#8A8A9A" }}>{p.views_count || 0} vues</p>
                </div>
                <span style={{ background: "#1A5C2A20", color: "#1A5C2A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600, height: "fit-content" }}>{p.post_type}</span>
              </div>
            ))
          }
        </div>
        <div style={{ background: "white", borderRadius: 20, padding: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
          <h3 style={{ margin: "0 0 16px", color: "#1A1A2E", fontSize: 16, fontWeight: 700 }}>Derniers signalements</h3>
          {recentReports.length === 0 
            ? <p style={{ color: "#8A8A9A", fontSize: 13 }}>Aucun signalement</p>
            : recentReports.map(r => (
              <div key={r.id} style={{ padding: "10px 0", borderBottom: "1px solid #F5F6FA", display: "flex", justifyContent: "space-between" }}>
                <div>
                  <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#1A1A2E" }}>{r.title?.substring(0, 30)}...</p>
                  <p style={{ margin: 0, fontSize: 12, color: "#8A8A9A" }}>{r.category}</p>
                </div>
                <span style={{ background: "#6A1B9A20", color: "#6A1B9A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600, height: "fit-content" }}>{r.status}</span>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}
